import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DealContainerComponent } from './components/deal-container/deal-container.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { SessionResolver } from './resolvers/session.resolver';
import {
  AllOrdersComponent,
  OverviewComponent,
  MonitorComponent,
  ReportsComponent,
  DealResolver,
  ALL_ORDERS,
  MONITOR,
  REPORTS
} from '@ipreo/muni-gameday';

const routes: Routes = [
  {
    path: '',
    canActivate: [SessionResolver],
    children: [
      {
        path: 'gameday/:id',
        component: DealContainerComponent,
        canActivate: [DealResolver],
        children: [
          {
            path: ALL_ORDERS,
            component: AllOrdersComponent,
            data: {
              section: 'All Orders',
              back: {
                remove: 1,
                keepParams: true
              }
            }
          },
          {
            path: REPORTS,
            component: ReportsComponent,
            data: {
              section: 'Reports',
              back: {
                remove: 1,
                keepParams: true
              }
            }
          },
          {
            path: MONITOR,
            component: MonitorComponent,
            data: {
              section: 'Order Monitor',
              back: {
                remove: 1,
                keepParams: true
              }
            }
          },
          {
            path: '',
            component: OverviewComponent,
            data: {
              back: {
                remove: 2,
                keepParams: false
              }
            }
          }
        ]
      }
    ]
  },
  {
    path: 'unauthorized',
    component: NotFoundComponent,
    data: {
      status: {
        code: 401
      },
      text: `
        Login failed. Sorry, you don't have permissions to view this page.
        This can be caused by expired token or wrong credentials.
        If the problem persists, please email munis@spglobal.com or call 212-849-5023 for immediate assistance.
      `
    }
  },
  {
    path: '**',
    component: NotFoundComponent,
    data: {
      status: {
        code: 404
      },
      text: 'Sorry, the page was not found.'
    }
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
